<template>
  <button
    :class="[
      'btn',
      {
        'btn--full': full,
        'btn--short': short,
        'btn--mobile': mobile,
       [`btn--${variant}`]: variant,
       [`btn--${size}`]: size,
       ['btn--negative']: negative,
       'btn--sec--negative': negative && (variant === 'secondary' || variant === 'tertiary'),
     }
    ]"
    @click="handleClick"
    :type="submit ? 'submit' : 'button'"
    :disabled="disabled || loading || uploading"
  >
    <slot />
    <span class="btn__loader" v-if="loading" />
    <span class="btn__uploader" v-if="uploading" />
  </button>
</template>

<script>
import KButton from './Button';

export default KButton;
</script>

<style lang="scss" src="./Button.scss" scoped></style>
